"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ContentTypes_1 = __importDefault(require("../entity/FacetParts/ContentTypes"));
const defaultValue = [
    { value: 'video/mp3', count: 123 },
    { value: 'video/quiqtime', count: 1234 },
    { value: 'image/png', count: 1234 },
    { value: 'image/jpg', count: 1234 },
];
exports.generateContentTypeEntity = (jsons = defaultValue) => ContentTypes_1.default.fromJSON({
    buckets: jsons,
});
